export default "__VITE_ASSET__BOg9utDr__"